import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps"
import SearchBox from "react-google-maps/lib/components/places/SearchBox"
import { MagnifierIcon } from "../../../Icons"
import googleApiKey from "../../../utils/googleApiKey"

const Map = ({
  name,
  value,
  setFieldValue,
  isMarkerShown,
  viewOnly,
  setFormattedAddress
}) => {
  const [initialState, setInitialState] = useState(
    value || { lat: null, lng: null, place_id: null, formatted_address: null }
  )

  const handleDragEnd = async value => {
    const lat = value.latLng.lat()
    const lng = value.latLng.lng()
    const getPlaceDetails = await getPlaceFromLatLng(lat, lng)
    if (lat !== null && lng !== null) {
      setFieldValue(name, {
        place_id: getPlaceDetails.place_id,
        lat: lat,
        lng: lng,
        formatted_address: getPlaceDetails.formatted_address
      })
      if (setFormattedAddress)
        setFormattedAddress(getPlaceDetails.formatted_address)
    } else {
      setFieldValue(name, null)
    }
  }

  const getPlaceFromLatLng = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}`
      )
      const { results } = await response.json()
      return results[0]
    } catch (error) {
      console.log(error)
    }
  }

  const onPlacesChanged = () => {
    const places = onSearchBoxMounted.current.getPlaces()
    const place_id = (places[0] && places[0].place_id) || null
    const formattedAddress = (places[0] && places[0].formatted_address) || null
    const lat = (places[0] && places[0].geometry.location.lat()) || null
    const lng = (places[0] && places[0].geometry.location.lng()) || null
    if (lat !== null && lng !== null) {
      setFieldValue(name, {
        place_id: place_id,
        lat: lat,
        lng: lng,
        formatted_address: formattedAddress
      })
    } else {
      setFieldValue(name, null)
    }
    if (setFormattedAddress) setFormattedAddress(formattedAddress)
  }

  const onMapBound = useRef(null)
  const onSearchBoxMounted = useRef(null)

  const options = {
    clickableIcons: !viewOnly,
    draggable: !viewOnly,
    disableDefaultUI: viewOnly,
    mapTypeControl: false,
    streetViewControl: false
  }

  useEffect(
    () => {
      const value_address = (value && value.formatted_address) || null
      if (initialState && value_address !== initialState.formatted_address) {
        setFormattedAddress(value_address || "")
        setInitialState(
          value || {
            lat: null,
            lng: null,
            place_id: null,
            formatted_address: null
          }
        )
      }
    },
    [value, initialState, setFormattedAddress]
  )

  const onLoad = useCallback(
    async () => {
      if (initialState.lat !== null && initialState.lng !== null) {
        const getPlaceDetails = await getPlaceFromLatLng(
          initialState.lat,
          initialState.lng
        )
        if (setFormattedAddress)
          setFormattedAddress(getPlaceDetails.formatted_address)
      }
    },
    [setFormattedAddress, initialState]
  )

  useEffect(
    () => {
      onLoad()
    },
    [onLoad]
  )

  return (
    <div>
      <GoogleMap
        ref={onMapBound}
        defaultOptions={options}
        defaultZoom={16}
        defaultCenter={{ lat: 14.6075852, lng: 121.0788904 }}
        center={
          value
            ? { lat: value.lat, lng: value.lng }
            : { lat: 14.6075852, lng: 121.0788904 }
        }
      >
        {!viewOnly ? (
          <SearchBox
            ref={onSearchBoxMounted}
            controlPosition={1}
            onPlacesChanged={onPlacesChanged}
          >
            <div className="searchBox">
              <MagnifierIcon />
              <input
                placeholder="Set Location"
                style={{
                  fontFamily: `Avenir`,
                  fontSize: `15px`,
                  color: `#898989`
                }}
              />
            </div>
          </SearchBox>
        ) : null}
        {isMarkerShown ? (
          <Marker
            draggable={!viewOnly}
            onDragEnd={handleDragEnd}
            position={
              value
                ? { lat: value.lat, lng: value.lng }
                : { lat: 14.6075852, lng: 121.0788904 }
            }
          />
        ) : null}
      </GoogleMap>
    </div>
  )
}

export default withScriptjs(withGoogleMap(Map))
